import React from 'react';
import MuiCardActions, { CardActionsProps as MuiCardActionsProps } from '@mui/material/CardActions';

export interface CardActionsProps extends MuiCardActionsProps {}

const CardActions = React.forwardRef<React.ComponentRef<typeof MuiCardActions>, CardActionsProps>(
  function CardActions(props, ref) {
    return <MuiCardActions ref={ref} {...props} />;
  },
);

export default CardActions;
